import React from "react";

export const schema = {
        title: "",
        description: "",
        type: "object",
        //required: ["title"],
        properties: {
            height: {type: "integer", title: "", default: ""},
            weight: {type: "integer", title: "", default: ""},
            lean_tissue_mass_percent: {type: "integer", title: "", default: ""},
            lean_tissue_mass_weight: {type: "integer", title: "", default: ""},
            adipose_tissue_mass_percent: {type: "integer", title: "", default: ""},
            adipose_tissue_mass_weight: {type: "integer", title: "", default: ""},
            bmi: {type: "integer", title: "", default: ""},
        }
}
// height, weight, lean_tissue_mass_percent,
// lean_tissue_mass_weight, adipose_tissue_mass_percent, adipose_tissue_mass_weight, bmi

export const uiSchema = {
    height: {
        "ui:widget": "updown",
        "ui:title": "1. What is your height in inches?", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Inches (for example: 64.5)",
        "ui:placeholder": "0"
    },
    weight: {
        "ui:widget": "updown",
        "ui:title": "2. What is your weight in pounds?",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Pounds (for example: 150.8)",
        "ui:placeholder": "0"
    },
    lean_tissue_mass_percent: {
        "ui:widget": "updown",
        "ui:title": "3. What is your lean tissue mass percent? ",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Percent (for example: 92.3)",
        "ui:placeholder": "0"
    },
    lean_tissue_mass_weight: {
        "ui:widget": "updown",
        "ui:title": "4. What is your lean tissue mass weight? ",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Pounds (for example: 132.8)",
        "ui:placeholder": "0"
    },
    adipose_tissue_mass_percent: {
        "ui:widget": "updown",
        "ui:title": "5. What is your adipose tissue mass percent? ",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Percent (for example: 12.4)",
        "ui:placeholder": "0"
    },
    adipose_tissue_mass_weight: {
        "ui:widget": "updown",
        "ui:title": "6. What is your adipose tissue mass weight? ",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Pounds (for example: 32.8)",
        "ui:placeholder": "0"
    },
    bmi: {
        "ui:widget": "updown",
        "ui:title": "7. What is your BMI?",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Body Mass Index",
        "ui:placeholder": "0"
    },
}



// WEBPACK FOOTER //
// ./src/components/assessment/schema/BodyComp.js